import React, { FunctionComponent } from "react";

const ImageFileLandscapeIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/files-folders/image-files/image-file-landscape
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.477,21.75a1.5,1.5,0,0,1-1.5,1.5H3.023a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.047.426l2.955,2.883a1.5,1.5,0,0,1,.452,1.074Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M6.023 7.500 A2.250 2.250 0 1 0 10.523 7.500 A2.250 2.250 0 1 0 6.023 7.500 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M18.813,18.2l-3.925-5.888a1.011,1.011,0,0,0-1.671-.019l-2.691,3.845L8.858,14.8a1.011,1.011,0,0,0-1.474.229L5.273,18.2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default ImageFileLandscapeIcon;
